/**
 * Shared multiselect-react-dropdown theme + interaction props.
 * Keep all Multiselect instances on the platform consistent.
 */
export const MULTISELECT_THEME_STYLE = {
  chips: { background: 'var(--theme-accent)', color: '#fff' },
  searchBox: {
    border: '1px solid var(--theme-input-border)',
    borderRadius: '8px',
    minHeight: '40px',
    background: 'var(--theme-input-bg)',
    color: 'var(--theme-text)',
  },
  optionContainer: {
    background: 'var(--theme-surface)',
    border: '1px solid var(--theme-border)',
  },
  option: {
    background: 'var(--theme-surface)',
    color: 'var(--theme-text)',
  },
};

/** Checkbox list that stays open while selecting */
export const MULTISELECT_COMMON_PROPS = {
  showCheckbox: true,
  closeOnSelect: false,
  avoidHighlightFirstOption: true,
};

export const FORM_SECTION_TITLE_STYLE = {
  color: 'var(--theme-accent)',
  borderBottom: '1px solid var(--theme-border)',
  paddingBottom: '5px',
  fontWeight: 600,
};
